import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M3 3a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h26a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zM3 8a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h26a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1zM2 14a1 1 0 0 1 1-1h26a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1zM3 18a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h26a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1z"
    }, null, -1)
  ])))
}
export default { render: render }